<template>
  <div class="podcast-section-bookend">
    <div v-if="loading" class="text-gray-600">
      Loading...
    </div>

    <div v-else>
      <ValidationObserver tag="div" ref="observer">
        <FormRow
          label="Titolo pagina"
          legend="(massimo 15 caratteri)"
          class="col-1/2"
          rules="required|max:15"
          name="Titolo"
        >
          <v-input type="text" v-model="modelData.title" />
        </FormRow>
      </ValidationObserver>

      <div class="add-element my-8">
        <button class="btn-round-icon-outline" @click="addElement">
          <IconPlus />
        </button>
        <span class="text-sans-base ml-2">Aggiungi elemento</span>
      </div>

      <RepeaterCollapse
        v-for="(element, index) of modelData.elements"
        :key="element._id"
        :open="element.open || false"
        ref="repeaters"
      >
        <template #header>
          <div class="bookend-header py-4">
            <div class="pointer-number">
              {{ index + 1 }}
            </div>
          </div>
        </template>
        <template #default>
          <div class="bookend-body w-1/2 py-4">
            <BookendElement
              :value="element"
              :podcast-id="id"
              :update-loading="updateLoading"
              @input="updateElement($event, index)"
              @valid="updateValidity($event, index)"
            />
          </div>
        </template>
        <template #actions>
          <div class="bookend-actions flex flex-col">
            <button
              type="button"
              class="btn-round-icon"
              @click="deleteElement(index)"
            >
              <IconTrash />
            </button>
            <button
              type="button"
              class="btn-round-icon mt-2"
              @click="moveElement(index, -1)"
              :disabled="index === 0"
            >
              <IconUp />
            </button>
            <button
              type="button"
              class="btn-round-icon mt-2"
              @click="moveElement(index, 1)"
              :disabled="index === modelData.elements.length - 1"
            >
              <IconDown />
            </button>
          </div>
        </template>
      </RepeaterCollapse>
    </div>
  </div>
</template>

<script>
import PodcastSectionBase from './PodcastSectionBase'
import GET_PODCAST_BOOKEND from '@/graphql/GetPodcastBookend.gql'
import UPDATE_PODCAST_BOOKEND from '@/graphql/UpdatePodcastBookend.gql'
import RepeaterCollapse from '@/components/RepeaterCollapse.vue'
import BookendElement from '@/components/BookendElement.vue'
import { ValidationObserver } from 'vee-validate'
import IconPlus from '@/assets/icons/icon-plus.svg'
import IconTrash from '@/assets/icons/icon-trash.svg'
import IconUp from '@/assets/icons/icon-arrow_up.svg'
import IconDown from '@/assets/icons/icon-arrow_down.svg'

export default {
  extends: PodcastSectionBase,

  components: {
    RepeaterCollapse,
    BookendElement,
    ValidationObserver,
    IconPlus,
    IconTrash,
    IconUp,
    IconDown,
  },

  section: {
    query() {
      return {
        query: GET_PODCAST_BOOKEND,
        variables: { podcastId: this.id },
      }
    },
    mutation() {
      return this.$apollo.mutate({
        mutation: UPDATE_PODCAST_BOOKEND,
        variables: {
          id: this.id,
          bookend: this.getCleanModelData(),
        },
      })
    },
    model() {
      return {
        title: null,
        elements: [],
      }
    },
    saveModel(data) {
      const bookend = data.findPodcastByID.bookend || {}
      const elements = (bookend.elements || []).map(element => ({
        ...element,
        _id: Math.random(),
      }))

      this.validities = elements.map(() => true)

      return {
        title: bookend.title || '',
        elements: elements,
      }
    },
  },

  data() {
    return {
      validities: [],
      titleValid: true,
    }
  },

  computed: {
    allValid() {
      return (
        this.validities.reduce(
          (currentValidity, totalValidity) => totalValidity && currentValidity,
          true,
        ) && this.titleValid
      )
    },
  },

  watch: {
    allValid(valid) {
      this.$store.commit('podcast/setValid', valid)
    },
  },

  mounted() {
    this.unwatchValidation = this.$watch(
      '$refs.observer.flags.valid',
      valid => {
        this.titleValid = valid
      },
      {
        immediate: true,
      },
    )
  },

  beforeDestroy() {
    this.$unwatchValidation && this.$unwatchValidation()
  },

  methods: {
    addElement() {
      if (this.$refs.repeaters) {
        this.$refs.repeaters.forEach(repeater => {
          repeater.$refs.collapse.hide()
        })
      }

      this.modelData.elements.push({
        _id: Math.random(),
        title: '',
        url: '',
        src: '',
        width: 400,
        height: 400,
        open: true,
      })

      this.validities.push(false)
    },
    updateElement(element, index) {
      this.$set(this.modelData.elements, index, { ...element })
    },
    getCleanModelData() {
      const elements = this.modelData.elements.map(element => ({
        title: element.title,
        url: element.url,
        src: element.src,
        width: element.width,
        height: element.height,
      }))

      return {
        title: this.modelData.title,
        elements,
      }
    },
    deleteElement(index) {
      this.modelData.elements.splice(index, 1)
      this.validities.splice(index, 1)
    },
    moveElement(index, offset) {
      const destination = index + offset
      this.modelData.elements.splice(
        destination,
        0,
        this.modelData.elements.splice(index, 1)[0],
      )

      this.validities.splice(
        destination,
        0,
        this.validities.splice(index, 1)[0],
      )
    },
    updateValidity(valid, index) {
      this.$set(this.validities, index, valid)
    },
    afterUpdate(err) {
      if (err) {
        console.dir(err)
      } else {
        this.initialModelData = {
          title: this.modelData.title,
          elements: this.modelData.elements.slice(),
        }
        this.markAsClean()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-collapse {
  @apply border-t border-gray-400;
}
</style>
